module.exports = __webpack_public_path__ + "static/media/77.7a862747.jpg";